import type { FaireProductEntity } from "../../entity_types/product";

export const p_dv9gxysset: FaireProductEntity = {
  token: "p_dv9gxysset",
  type: "product",
  name: "24K Gold Filled Pastel Marquise CZ Stud Earring| AB1236-1239",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/35c2af42e9a182d6a8bd519ba4a9e383ec3397cef8314f46a11ae88c964f8ba9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a5098ae5e7628b56ec820a2e3d022a2390b4e0e9b6033c346ce7e02e15541bf8.jpeg",
    "https://cdn.faire.com/fastly/35f228d0c8087e5bab8d15d55ec62a4e9ca5dfac95a539a67e2ee1e1745959cc.jpeg",
    "https://cdn.faire.com/fastly/5cb517db0396b6a1309d429fbca973a7a5ee3eb1e3f886851cb4850a9fbcec2c.jpeg",
    "https://cdn.faire.com/fastly/b5ef74f2b942602db1e88a2f8abf08a670096a1bf4989b78b0ac5a247d5683d0.jpeg",
    "https://cdn.faire.com/fastly/fea8e47e8c97f1c45c0441ce86a340eba3d628f79ab82b3ed48f1c3fc60888b5.jpeg",
    "https://cdn.faire.com/fastly/0e16c759c5e9a073f01a6aa006d9d06d4bc3ec7b4f0d847df477937f467c431b.jpeg",
    "https://cdn.faire.com/fastly/28adc8b73d695d1521d724562b06f8703095e307a57bc977590e8e5a9f3c4435.jpeg",
  ],
  priceDollars: 5.54,
  description:
    "Material: Brass, 24K Gold-Filled, Cubic Zirconia\nSize: 14mm x 7.4mm x 6.8mm\nQuantity: 1 Pair\nColor: Gold\nTheme: Geometric & Chain Links \nLead Free, Nickel Free",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:52.609Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
